import * as LucideIcons from 'lucide-vue-next'
import type { LucideIcon } from 'lucide-vue-next'

export type LucideIconNameType = typeof LucideIcons

const lucideIcons = {} as Record<keyof LucideIconNameType, LucideIcon>

const lucideIconsNames: (keyof LucideIconNameType)[] = []

for (const name of Object.keys(LucideIcons)) {
  if (!name.endsWith('Icon') && !name.startsWith('Lucide')) {
    lucideIconsNames.push(name as keyof LucideIconNameType)
    lucideIcons[name] = LucideIcons[name]
  }
}

export { lucideIconsNames, lucideIcons }
